<template>
<v-card
  flat
  unelevated
  tile
  fill-height
>
  <v-overlay :absolute="true" :value="dataLoading" :opacity="1" color="white">
    <v-progress-circular
      :size="70"
      :width="9"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
  <v-sheet>
    <div class="text-center primary--text text-h5 py-4">
      {{title}}
    </div>
  </v-sheet>
  <npo-card :npo="npo" :expanded="cardExpanded" v-if="cardHidden"/>
  <component :is="bodyComponent" :bodyProps="bodyProps" @vote-npo="voteNpo"/>
</v-card>
</template>

<script>
import apiService from '@/services'
import npoCard from './NpoCard'
import voteResult from './VoteResult'
import leadForm from '@/components/qrcode-vote-components/BaseLeadForm'
import voteButton from '@/components/qrcode-vote-components/BaseVoteButton'

export default {
  props: {
    title: {
      type: String
    },
    npo: {
      type: Object
    },
    leadId: {
      type: String,
      default: ''
    },
    isLeading: {
      type: Boolean,
      default: false
    },
    token: {
      type: String
    },
    skipConfig: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'npo-card': npoCard,
    // eslint-disable-next-line vue/no-unused-components
    'vote-result': voteResult,
    'lead-form': leadForm,
    'vote-button': voteButton
  },
  computed: {
    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out action header
      return this.tableHeaders.filter((item) => item.value !== 'action')
    }
  },
  data () {
    return {
      imageUrl: '@/assets/the_good_company_logo.jpg',
      bodyComponent: '',
      bodyProps: {},
      campaignId: null,
      dataLoading: false,
      cardExpanded: true,
      cardHidden: true,
      voted: false
    }
  },

  created () {
    console.log('NPO', this.npo)
    if (JSON.parse(sessionStorage.getItem('campaign'))) {
      const campaign = JSON.parse(sessionStorage.getItem('campaign'))
      this.campaign = campaign
      this.campaignId = campaign.campaign_id
    } else {
      this.campaignId = sessionStorage.getItem('campaign_id')
    }

    // If prompted go directly to vote
    if (this.skipConfig) {
      this.voteNpo()
    }

    if (this.isLeading) {
      this.bodyComponent = 'lead-form'
    } else {
      this.bodyComponent = 'vote-button'
      this.bodyProps = {
        label: 'Conferma!',
        size: 'lg',
        aspect: 'square',
        elevation: 'flat',
        campaign: this.campaign
      }
    }
  },

  methods: {
    voteNpo () {
      console.log('VOTE NPO')
      this.dataLoading = true
      let data = {
        token: sessionStorage.getItem('qrcodeToken'),
        npo: this.npo.id
      }

      apiService
        .giftcardVoteNpo(data)
        .then(() => {
          apiService
            .getNpoBanners(this.npo.id)
            .then((response) => {
              this.bodyProps.banners = response
              this.bodyComponent = 'vote-result'
            })
          sessionStorage.setItem(
            'voted', 'true'
          )
          this.$emit('has-voted')
          this.voted = true
          this.title = 'Grazie per aver scelto'
          this.bodyProps.status = 'success'
          this.cardExpanded = false
          this.dataLoading = false
        })
        .catch((error) => {
          console.log('error', error)
          this.bodyComponent = 'vote-result'
          this.title = 'Qualcosa è andato storto'
          this.bodyProps = { status: 'error' }
          this.cardHidden = false
          this.dataLoading = false
        })
    },

    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
.v-navigation-drawer {
  transition: none !important;
}

.v-content {
  background-color: #fff;
}

.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  );
}
</style>
